// import MetricCard from "pages/admin-dashboard/components/MetricCard";
// import React, { useState, useMemo } from "react";

// const LeaveList = ({ leaves }) => {
//     console.log("Leaves data:", leaves);
//     const [statusFilter, setStatusFilter] = useState("all");
//     const [page, setPage] = useState(1);
//     const rowsPerPage =5; // configurable

//     // Metrics cards
//     const metrics = [
//         {
//             title: "Total Leaves",
//             value: leaves?.summary?.total_leaves || "0",
//             icon: "Users",
//             iconColor: "text-primary",
//         },
//         {
//             title: "Paid Leaves",
//             value: leaves?.summary?.total_paid || "0",
//             icon: "UserCheck",
//             iconColor: "text-primary",
//         },
//         {
//             title: "LOP Days",
//             value: leaves?.summary?.total_lop || "0",
//             icon: "AlertTriangle",
//             iconColor: "text-success",
//         },
//         {
//             title: "Remaining Paid (This Month)",
//             value: leaves?.summary?.remaining_paid_leave_this_month || "0",
//             icon: "Calendar",
//             iconColor: "text-error",
//         },
//     ];

//     // ✅ Apply filter + pagination
//     const filteredLeaves = useMemo(() => {
//         let data = Array.isArray(leaves?.leaves) ? leaves.leaves : [];
//         if (statusFilter !== "all") {
//             data = data.filter(
//                 (leave) => leave?.status?.toLowerCase() === statusFilter
//             );
//         }
//         return data;
//     }, [leaves, statusFilter]);

//     const totalPages = Math.ceil(filteredLeaves.length / rowsPerPage);
//     const paginatedLeaves = filteredLeaves.slice(
//         (page - 1) * rowsPerPage,
//         page * rowsPerPage
//     );

//     return (
//         <>
//             {leaves?.summary && (
//                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6">
//                     {metrics.map((metric, index) => (
//                         <MetricCard
//                             key={index}
//                             title={metric.title}
//                             value={metric.value}
//                             icon={metric.icon}
//                             iconColor={metric.iconColor}
//                         />
//                     ))}
//                 </div>
//             )}

//             <div className="bg-white p-6 rounded-lg shadow">
//                 <div className="flex items-center justify-between mb-4">
//                     <h2 className="text-lg font-semibold">My Leaves</h2>

//                     {/* ✅ Filter Dropdown */}
//                     <select
//                         className="border rounded p-2 text-sm"
//                         value={statusFilter}
//                         onChange={(e) => {
//                             setStatusFilter(e.target.value);
//                             setPage(1); // reset page
//                         }}
//                     >
//                         <option value="all">All</option>
//                         <option value="approved">Approved</option>
//                         <option value="pending">Pending</option>
//                         <option value="rejected">Rejected</option>
//                     </select>
//                 </div>

//                 {paginatedLeaves.length > 0 ? (
//                     <div className="overflow-x-auto">
//                         <table className="w-full">
//                             <thead className="bg-muted">
//                                 <tr>
//                                     <th className="p-3 text-left">Type</th>
//                                     <th className="p-3 text-left">Start</th>
//                                     <th className="p-3 text-left">End</th>
//                                     <th className="p-3 text-left">Status</th>
//                                     <th className="p-3 text-left">Reason</th>
//                                     <th className="p-3 text-left">Paid Days</th>
//                                     <th className="p-3 text-left">LOP Days</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {paginatedLeaves.map((leave) => (
//                                     <tr
//                                         key={leave?.id}
//                                         className="border-b border-border hover:bg-muted/50 transition-colors"
//                                     >
//                                         <td className="p-3">{leave?.leave_type}</td>
//                                         <td className="p-3">{leave?.start_date}</td>
//                                         <td className="p-3">{leave?.end_date}</td>
//                                         <td className="p-3">{leave?.status}</td>
//                                         <td className="p-3">{leave?.reason}</td>
//                                         <td className="p-3">{leave?.paid_days}</td>
//                                         <td className="p-3">{leave?.lop_days}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 ) : (
//                     <p className="text-sm text-gray-500">No leaves found.</p>
//                 )}

//                 {/* ✅ Pagination Controls */}
//                 {totalPages > 1 && (
//                     <div className="flex justify-end items-center mt-4 space-x-2">
//                         <button
//                             disabled={page === 1}
//                             onClick={() => setPage((p) => p - 1)}
//                             className="px-3 py-1 border rounded disabled:opacity-50"
//                         >
//                             Prev
//                         </button>
//                         <span className="text-sm">
//                             Page {page} of {totalPages}
//                         </span>
//                         <button
//                             disabled={page === totalPages}
//                             onClick={() => setPage((p) => p + 1)}
//                             className="px-3 py-1 border rounded disabled:opacity-50"
//                         >
//                             Next
//                         </button>
//                     </div>
//                 )}
//             </div>
//         </>
//     );
// };

// export default LeaveList;


import MetricCard from "pages/admin-dashboard/components/metricCard";
import React, { useState, useMemo } from "react";

const LeaveList = ({ data }) => {
    console.log("Leave API data:", data);

    // ✅ Extract months from API
    const months = useMemo(() => {
        if (!Array.isArray(data?.months)) return [];
        // Sort months oldest → newest
        return [...data.months].sort((a, b) => a.month_key.localeCompare(b.month_key));
    }, [data]);

    // ✅ Default month → current month if available, else latest
    const todayKey = new Date().toISOString().slice(0, 7);
    const defaultIndex = months.findIndex((m) => m.month_key === todayKey);
    const [currentMonthIndex, setCurrentMonthIndex] = useState(
        defaultIndex !== -1 ? defaultIndex : months.length - 1
    );

    const currentMonth = months[currentMonthIndex] || {};
    const monthLeaves = currentMonth.leaves || [];

    // ✅ Format month display
    const formatMonth = (monthKey) => {
        if (!monthKey) return "";
        const [year, month] = monthKey.split("-");
        const date = new Date(year, month - 1);
        return date.toLocaleString("default", { month: "long", year: "numeric" });
    };

    // ✅ Metrics for current month
    const monthMetrics = [
        { title: "Total Leaves", value: currentMonth?.summary?.total_leaves || 0, icon: "Users", iconColor: "text-primary" },
        { title: "Paid Leaves", value: currentMonth?.summary?.total_paid || 0, icon: "UserCheck", iconColor: "text-primary" },
        { title: "LOP Days", value: currentMonth?.summary?.total_lop || 0, icon: "AlertTriangle", iconColor: "text-success" },
        { title: `Remaining Paid (${formatMonth(currentMonth.month_key)})`, value: currentMonth?.remaining_paid_leave_this_month || 0, icon: "Calendar", iconColor: "text-error" },
        { title: "Monthly Quota", value: currentMonth?.monthly_quota || 0, icon: "Briefcase", iconColor: "text-info" },
        { title: "Used This Month", value: currentMonth?.used_this_month || 0, icon: "CheckCircle", iconColor: "text-warning" },
    ];

    // ✅ Total summary metrics
    const totalMetrics = [
        { title: "Total Leaves", value: data?.total_summary?.total_leaves || 0, icon: "Users", iconColor: "text-primary" },
        { title: "Total Paid", value: data?.total_summary?.total_paid || 0, icon: "UserCheck", iconColor: "text-primary" },
        { title: "Total LOP", value: data?.total_summary?.total_lop || 0, icon: "AlertTriangle", iconColor: "text-success" },
        { title: "Monthly Quota", value: data?.total_summary?.monthly_quota || 0, icon: "Briefcase", iconColor: "text-info" },
    ];

    return (
        <div className="bg-white p-6 rounded-lg shadow">
            {/* Employee Info */}
            {data?.employee && (
                <div className="mb-6">
                    <h2 className="text-lg font-semibold">{`${data.employee.first_name} ${data.employee.last_name}`}</h2>
                    <p className="text-sm text-gray-500">{data.employee.email}</p>
                </div>
            )}

            {/* Total Summary Metrics */}
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                {totalMetrics.map((metric, index) => (
                    <MetricCard
                        key={`total-${index}`}
                        title={metric.title}
                        value={metric.value}
                        icon={metric.icon}
                        iconColor={metric.iconColor}
                    />
                ))}
            </div> */}

            {/* Month Selector */}
            <div className="flex justify-start items-center mb-6">
                <h2 className="text-xl font-bold">Month: </h2>
                <select
                    className="border p-2 rounded"
                    value={currentMonth?.month_key || ""}
                    onChange={(e) => {
                        const selectedIndex = months.findIndex((m) => m.month_key === e.target.value);
                        if (selectedIndex !== -1) setCurrentMonthIndex(selectedIndex);
                    }}
                >
                    {months.map((m) => (
                        <option key={m.month_key} value={m.month_key}>
                            {formatMonth(m.month_key)}
                        </option>
                    ))}
                </select>
            </div>

            {/* Current Month Metrics */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                {monthMetrics.map((metric, index) => (
                    <MetricCard
                        key={`month-${index}`}
                        title={metric.title}
                        value={metric.value}
                        icon={metric.icon}
                        iconColor={metric.iconColor}
                    />
                ))}
            </div>

            {/* Leave Table */}
            {monthLeaves.length > 0 ? (
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-muted">
                            <tr>
                                <th className="p-3 text-left">Type</th>
                                <th className="p-3 text-left">Start</th>
                                <th className="p-3 text-left">End</th>
                                <th className="p-3 text-left">Status</th>
                                <th className="p-3 text-left">Reason</th>
                                <th className="p-3 text-left">Paid Days</th>
                                <th className="p-3 text-left">LOP Days</th>
                            </tr>
                        </thead>
                        <tbody>
                            {monthLeaves.map((leave) => (
                                <tr
                                    key={leave.id}
                                    className="border-b border-border hover:bg-muted/50 transition-colors"
                                >
                                    <td className="p-3">{leave.leave_type}</td>
                                    <td className="p-3">{leave.start_date}</td>
                                    <td className="p-3">{leave.end_date}</td>
                                    <td className="p-3">{leave.status}</td>
                                    <td className="p-3">{leave.reason}</td>
                                    <td className="p-3">{leave.paid_days}</td>
                                    <td className="p-3">{leave.lop_days}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <p className="text-sm text-gray-500">No leaves found for this month.</p>
            )}
        </div>
    );
};

export default LeaveList;
